var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoneStepCapitalGains(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0006 16V24C38.0006 24.2652 37.8952 24.5196 37.7077 24.7071C37.5201 24.8946 37.2658 25 37.0006 25C36.7353 25 36.481 24.8946 36.2934 24.7071C36.1059 24.5196 36.0006 24.2652 36.0006 24V18.4137L25.7081 28.7075C25.6152 28.8005 25.5049 28.8742 25.3835 28.9246C25.2621 28.9749 25.132 29.0008 25.0006 29.0008C24.8691 29.0008 24.739 28.9749 24.6176 28.9246C24.4962 28.8742 24.3859 28.8005 24.2931 28.7075L20.0006 24.4137L11.7081 32.7075C11.5204 32.8951 11.2659 33.0006 11.0006 33.0006C10.7352 33.0006 10.4807 32.8951 10.2931 32.7075C10.1054 32.5199 10 32.2654 10 32C10 31.7346 10.1054 31.4801 10.2931 31.2925L19.2931 22.2925C19.3859 22.1995 19.4962 22.1258 19.6176 22.0754C19.739 22.0251 19.8691 21.9992 20.0006 21.9992C20.132 21.9992 20.2621 22.0251 20.3835 22.0754C20.5049 22.1258 20.6152 22.1995 20.7081 22.2925L25.0006 26.5863L34.5868 17H29.0006C28.7353 17 28.481 16.8946 28.2934 16.7071C28.1059 16.5196 28.0006 16.2652 28.0006 16C28.0006 15.7348 28.1059 15.4804 28.2934 15.2929C28.481 15.1054 28.7353 15 29.0006 15H37.0006C37.2658 15 37.5201 15.1054 37.7077 15.2929C37.8952 15.4804 38.0006 15.7348 38.0006 16Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoneStepCapitalGains);
export default __webpack_public_path__ + "static/media/undone-step-capital-gains.7501f0c85d174b6f3a57484b0a6564c7.svg";
export { ForwardRef as ReactComponent };